import React from "react"
import { storyblokEditable } from "gatsby-source-storyblok"

const Images = ({ blok }) => {
  // console.log(blok);

  const imagesComponent = blok.Images.map((image, index) => (
    <img className="w-full max-w-[570px] md:max-w-[650px] h-auto" loading="lazy" src={`${image.filename}/m/0x1000`} alt={image.alt} key={index}/>
  ))

  return (
    <div className="flex justify-center" {...storyblokEditable(blok)} >
      <div className="w-[90vw] m-center flex justify-center gap-6 lg:gap-14 flex-wrap lg:flex-nowrap justify-items-center">
        {imagesComponent}
      </div>
    </div>
  )
}

export default Images
